module.exports = __webpack_public_path__ + "gpnz.jpg?2c57cb62b9f075ef547dbcfd4337a485";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gpnz.jpg
// module id = 385
// module chunks = 0